// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"79021cce","410":"badcec44","440":"664e6b6a","455":"be3c86b9","488":"dc27bfb4","503":"2142d519","593":"3f17ab01","612":"13464de9","733":"a0e299c6","804":"072eeb62","860":"41f94d6c","883":"684b7c90","953":"40715b51","977":"0a094501"}[chunkId] + ".chunk.js";
};